/* src/app/user-default/hiring/hiring.component.scss */
.card-detail {
  margin: 0 20px;
  max-width: 42rem;
}
/*# sourceMappingURL=hiring.component-SU72NR4R.css.map */
